import axios from "axios";
import { getCookie, setCookie } from "@/utils";

// 本地/线上
const baseURL = process.env.NODE_ENV === "production" ? '' : '';

const service = axios.create({
    baseURL,
    timeout: 30000,
    withCredentials: true
});

service.interceptors.request.use((config) => {
    return config;
});


service.interceptors.response.use(
    response => {
        if ("x-access-token" in response.headers) {
            setCookie("jtoken", response.headers["x-access-token"], 30);
        }

        const { code, data, message } = response.data;
        // console.log(response.data)
        // if (code === 401 || response.status === 401) {
        //     store.commit('commitOpenModal')
        //     return null;
        // } else if (code === 200) {
        if (code === 200 || code === 1) {
            return data;
        } else {
            return [];
        }
    },
    error => {
        return Promise.reject(error);
    }
);


function getParamsStr(params = {}) {
    let str = "?"
    let arr = Object.keys(params);

    arr = arr.map(key => {
        return key + "=" + params[key]
    })

    str += arr.join("&");

    return str;
}

/**
 * @param url 请求路由
 * @param method 请求方法
 * @param data 请求参数
 */
export default function httpServer({ url, data, method = "GET" }) {
    // if (store.state.openModal) {
    //     return Promise.reject("用户在别处登录，或权限不足，请重新登录");
    // }

    if (method === "GET" && data) {
        url = url + getParamsStr(data);
    }

    return service.request({
        url,
        method,
        data: method === "POST" ? data : null,
        headers: {
            "Content-Type": "application/json",
            // "x-access-token": getCookie('jtoken') || ""
        }
    })
}
